var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcNootbook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M952.619 525.07L952.54 524.872L961.54 480.905L962.412 480.667L961.54 484.866L953.293 525.228L952.857 525.347L952.699 525.189V525.149L952.619 525.07Z",
    fill: "#323142"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M962.412 478.766V480.667L961.54 480.905V479.003L962.412 478.766Z",
    fill: "#4E5067"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M961.619 476.864L962.412 478.765L961.54 479.003L960.747 477.102L961.619 476.864Z",
    fill: "#4E5067"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M961.619 476.864L960.747 477.102L959.518 475.874L960.39 475.676L961.619 476.864Z",
    fill: "#4E5067"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M960.39 475.676L959.518 475.874L910.671 447.711L911.544 447.473L960.39 475.676Z",
    fill: "#575974"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M911.544 447.473L910.671 447.711L909.284 447.394L910.156 447.156L911.544 447.473Z",
    fill: "#4E5067"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M959.478 480.073L959.438 480.231L909.442 451.434L901.393 490.847L901.235 490.767L909.323 451.157L958.368 479.439L959.478 480.073Z",
    fill: "#7A8092"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M909.324 451.157L901.236 490.767L901.037 490.807L901.077 490.688L909.205 451.038L909.324 451.157Z",
    fill: "#3F4046"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M961.539 479.003V480.904L952.539 524.872L945.284 520.713L945.323 520.594L951.984 524.476L960.984 480.667V479.082L960.35 477.538L959.319 476.547L910.631 448.464L909.402 448.186L908.371 448.741L907.777 449.969L899.609 489.975L898.816 493.778L905.517 497.66V497.699L905.477 497.739L898.261 493.58V493.461L907.261 449.573L907.975 448.107L909.283 447.394L910.671 447.711L959.517 475.874L960.746 477.102L961.539 479.003Z",
    fill: "#3E4054"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M959.437 480.231L959.477 480.073L958.367 479.439L909.322 451.157L909.163 451.078L901.036 490.688L900.996 490.807L951.27 519.802L951.309 519.683L959.437 480.231ZM960.984 479.082V480.667L952.023 524.476L945.362 520.634L905.556 497.66L898.855 493.778L899.648 489.975L907.855 450.008L908.45 448.781L909.481 448.226L910.67 448.503L959.358 476.587L960.389 477.617L960.984 479.082Z",
    fill: "#474650"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M959.438 480.231L951.349 519.683L901.393 490.847L909.441 451.434L959.438 480.231Z",
    fill: "#9D9CA7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M952.659 525.149H952.699V525.189V527.209L949.963 528.793L926.135 542.538L921.02 545.469L917.252 547.7L917.412 545.469L929.148 538.696L948.139 527.764L952.659 525.149Z",
    fill: "#373641"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M875.979 524.08L900.759 538.379L913.764 530.853L889.002 516.702L875.781 524.001L875.979 524.08ZM928.275 538.181L946.553 527.645L946.91 527.447L947.266 527.249L941.279 523.803L940.923 523.605L901.473 500.868L901.116 500.67L895.129 497.224L894.772 497.026L894.415 497.224L875.781 507.958L876.138 508.156L876.217 508.196L876.494 508.355L889.34 515.762L914.676 530.378L928.275 538.181ZM944.61 521.466L945.205 521.109L945.601 521.069L952.659 525.189L948.178 527.764L929.187 538.736L917.411 545.509L915.746 546.064H913.645L911.98 545.509L874.909 524.119L863.133 517.346L862.142 516.395V515.207L863.133 514.256L874.909 507.483L898.42 493.936L898.539 494.055L905.477 498.056L905.438 498.254L904.764 498.65L944.57 521.584L944.61 521.466Z",
    fill: "#474650"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M951.351 519.683V519.802L901.037 490.807L901.394 490.847L951.351 519.683Z",
    fill: "#3B3A3C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M947.266 527.209L946.909 527.447L940.923 524.001L940.566 523.803L901.116 501.027L900.759 500.829L895.169 497.581L894.97 497.501V497.462L894.812 496.986L895.169 497.185L901.116 500.631L901.473 500.829L940.923 523.565L941.279 523.803L947.266 527.209Z",
    fill: "#545673"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M946.91 527.447L946.513 527.645L940.566 524.199L900.759 501.264L894.812 497.818L876.534 508.354L876.257 508.196H876.415L894.971 497.501L895.169 497.58L900.759 500.828L901.116 501.027L940.566 523.802L940.923 524.001L946.91 527.447Z",
    fill: "#2D2F42"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M946.513 527.645L928.275 538.181L914.675 530.378L889.38 515.762L876.534 508.354L894.812 497.818L900.759 501.264L940.566 524.199L946.513 527.645Z",
    fill: "#2C2E41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M945.284 520.792L945.204 521.109L944.61 521.465L905.636 499.006L905.517 498.927L905.398 498.135L905.437 497.977L905.477 497.858V497.739L905.517 497.699V497.66L945.323 520.594L945.284 520.713V520.792Z",
    fill: "#222433"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M905.636 499.006L944.61 521.465L944.531 521.505L904.764 498.531L905.279 498.808L905.517 498.927L905.636 499.006Z",
    fill: "#836B50"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M913.805 530.893L900.76 538.379L875.98 524.08L889.024 516.593L913.805 530.893Z",
    fill: "#2B2A38"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M917.251 548.223L917.714 545.907C915.825 546.745 914.26 546.705 912.157 545.907L863.068 517.658C862.401 517.275 862.259 516.802 862.142 515.806C861.822 518.309 862.007 519.267 863.068 519.973L912.157 548.223C914.166 548.925 915.29 548.967 917.251 548.223Z",
    fill: "url(#paint0_linear_2045_1625)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M901.236 490.767L901.394 490.847L901.037 490.807L901.236 490.767Z",
    fill: "#3D4248"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M894.971 497.462V497.501L876.415 508.196H876.257L876.177 508.117L894.416 497.58L894.812 497.382L894.971 497.462Z",
    fill: "#232535"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M894.812 496.986L894.97 497.462L894.812 497.383V496.986Z",
    fill: "#56463B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M894.812 496.986V497.383L894.416 497.581L876.177 508.117L875.821 507.919L894.416 497.185L894.812 496.986Z",
    fill: "#2B2D3E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M889.023 516.593L875.979 524.08L875.821 524L888.825 516.474L889.023 516.593Z",
    fill: "#252434"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M952.448 486.63L911.231 463.938L906.137 491.261L946.89 514.879L952.448 486.63Z",
    fill: "#EAEAEC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M939 484.5L912 469.5L908 489.5L935 505L939 484.5Z",
    fill: "#8CCDDE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M952.447 486.63L911.231 463.938L910.768 466.716L951.984 489.409L952.447 486.63Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2045_1625",
    x1: 866.31,
    y1: 519.047,
    x2: 915.399,
    y2: 547.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#373641"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcNootbook);
export default __webpack_public_path__ + "static/media/ACNootbook.3f4d262806c04353f2afca506dd5cee2.svg";
export { ForwardRef as ReactComponent };